<aside class="sidebar" [class.sidebar--collapsed]="!isExpanded()" [class.sidebar--overlay]="isOverlay()">
  <div class="sidebar__header">
    <div class="logo">
      @if (isExpanded()) {
      <div class="logo__text">
        <img src="assets/logo.png" />
      </div>
      } @else {
      <div class="logo__icon">
        <img src="assets/logo-2.png" />
      </div>
      }
    </div>
  </div>

  <nav class="sidebar__nav">
    <div class="menu-group">
      <ul class="menu">
        @for (item of primaryMenuItems(); track item.route) {
        <li class="menu__item">
          <a [routerLink]="item.route" routerLinkActive="menu__link--active" class="menu__link"
            [class.menu__link--icon-only]="!isExpanded()" [title]="!isExpanded() ? item.label : ''">
            <i [class]="item.icon + ' menu__icon'"></i>
            @if (isExpanded()) {
            <span class="menu__label">{{ item.label }}</span>
            }
          </a>
        </li>
        }
      </ul>
    </div>

    @if(secondaryMenuItems().length) {
    <div class="menu-group menu-group--secondary">
      <ul class="menu">
        @for (item of secondaryMenuItems(); track item.route) {
        <li class="menu__item">
          <a [routerLink]="item.route" routerLinkActive="menu__link--active" class="menu__link"
            [class.menu__link--icon-only]="!isExpanded()" [title]="!isExpanded() ? item.label : ''">
            <i [class]="item.icon + ' menu__icon'"></i>
            @if (isExpanded()) {
            <span class="menu__label">{{ item.label }}</span>
            }
          </a>
        </li>
        }
      </ul>
    </div>
    }

    <!-- Toggle button: always visible -->
    <div class="sidebar__expand-row" [class.sidebar__expand-row--open]="isExpanded()">
      <button type="button" class="sidebar__expand-btn" (click)="onToggle()"
        [title]="isExpanded() ? 'Cerrar menú' : 'Expandir menú'">
        <i [class]="isExpanded() ? 'pi pi-chevron-left' : 'pi pi-chevron-right'"></i>
        @if (isExpanded()) {
        <span>Cerrar menú</span>
        }
      </button>
    </div>
  </nav>

  <div class="sidebar__footer">
  <div class="buttons-wrapper">
    @if (isExpanded() && !isProduction) {
      <button type="button" class="debug-btn" (click)="showDebugModal.set(true)">
        <i class="pi pi-wrench debug-btn__icon"></i>
        <span class="debug-btn__label">Debug</span>
      </button>
      }
      <span class="app-version">v1.2</span>

      <button type="button" class="sidebar__logout-btn" title="Cerrar sesión" (click)="onLogout()">
        <i class="pi pi-power-off"></i>
      </button>
    </div>

    <div class="user-row">
      <div class="user" [class.user--icon-only]="!isExpanded()">
        <div class="user__avatar">
          <i class="pi pi-user"></i>
        </div>
        @if (isExpanded()) {
        <div class="user__info">
          <span class="user__name">{{ currentUserName() }}</span>
          <div class="profile_links_wrapper">
            <a routerLink="/profile" class="user__profile-link">Mi perfil</a>
            @if (permissionService.hasAnyPermission([AppPermission.UiCompanyProfile])) {
              <a routerLink="/company-profile" class="user__profile-link">Perfil de empresa</a>
            }
          </div>
        </div>
        }
      </div>

    </div>
    <p-confirmDialog></p-confirmDialog>
  </div>

</aside>

<app-debug-modal [(visible)]="showDebugModal"></app-debug-modal>